import { Cta, SanityCtaProps } from "@/components/cta"
import { RichText, RichTextValue } from "@/components/rich-text"
import Link from "next/link"
import { SlideOnView } from "@/components/slide-on-view"

interface ContactUsFormProps {
  content: {
    title: RichTextValue
    description: string
    ctas: SanityCtaProps[]
    socials: {
      title: string
      url: string
    }[]
  }
}

export function ContactUsForm({ content }: ContactUsFormProps) {
  return (
    <div className="mx-auto max-w-[166rem] overflow-hidden bg-neutral-light px-6 py-5 pb-20 md:px-16 md:py-25 lg:px-20 xl:px-35">
      <SlideOnView>
        <RichText boxClassName="text-primary-500" value={content.title} />
      </SlideOnView>

      <div className="mt-6 flex w-full flex-col gap-8 font-family-gthaptik font-light text-neutral-dark md:mt-10 md:w-[50rem] lg:mt-16">
        <SlideOnView delay={0.2} className="text-md">
          {content.description}
        </SlideOnView>
        <SlideOnView delay={0.4} className="flex items-start gap-x-4">
          {content.ctas?.map(
            (cta, index) => cta?.label && <Cta key={index} sanity={cta} />
          )}
        </SlideOnView>

        <SlideOnView delay={0.6}>
          <p className="text-xl text-primary-800">Social</p>
          <div className="mt-4 flex flex-col gap-2.5">
            {content.socials.map((social, i) => (
              <Link
                key={i}
                href={social.url}
                target="_blank"
                className="block text-lg underline xl:text-xlg"
              >
                {social.title}
              </Link>
            ))}
          </div>
        </SlideOnView>
      </div>
    </div>
  )
}
